import { LifecycleCommand } from '@/shared/types/types.generated';

// Their agent has no START/STOP handler: it reports success and keeps running.
export const SUPPORTED_LIFECYCLE_COMMAND = LifecycleCommand.Restart;

export const ORCHESTRATOR_ID_PATTERN = /^[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}$/;

// The installer wipes its certificate if nobody claims the id in this window, which
// starts when the customer runs the command — unobservable here, so never counted down.
export const REGISTRATION_WINDOW_MINUTES = 5;

export const LATEST_RUNTIME_VERSION = 'latest';

export const VPLC_POLLING_INTERVAL_MS = 5_000;

export const ORCHESTRATOR_POLLING_INTERVAL_MS = 30_000;

export const PROVISIONING_I18N_PREFIX = 'openplc:provisioning';

export const AUTONOMY_VENDOR_ID = 'autonomy';

// The CLI branches on this key alone: misspelt, a snapshot silently reads the host's Runtime.
export const AUTONOMY_VPLC_ID_META_KEY = 'autonomy_vplc_id';
